import clsx from "clsx"

import { AppIcon } from "@atoms"

import { useComponentNavigation } from "@organisms/ComponentNavigation/ComponentNavigation.context"

import styles from "./AuthHeader.module.scss"

export default function AuthHeader() {
    const { currentComponentId } = useComponentNavigation()
    const isOnOTPSlide = currentComponentId?.endsWith("_otp")

    return (
        <>
            <AppIcon />
            <div className={styles.titleContainer}>
                <div
                    className={clsx(styles.title, {
                        [styles.titleActive]: isOnOTPSlide,
                    })}
                >
                    Enter login code
                </div>
                <div
                    className={clsx(styles.title, {
                        [styles.titleActive]: !isOnOTPSlide,
                    })}
                >
                    Sign in to Roopairs
                </div>
            </div>
        </>
    )
}
